import { imageCdnPath } from './vd-image-cdn-path'

/**
 * Get the user's image URL
 *
 * @param  {User} user
 *         The user to get the image path of
 *
 * @param  {String} size
 *         The size of the image to be returned
 *
 * @return {String} The user's image path
 */
export function userImagePath(user, size = 'sm') {
  const NO_AVATAR_TEST = /\/no-image-white-ss\.png$/

  if (!user || !user.image_source || user.image_source.match(NO_AVATAR_TEST)) {
    return imageCdnPath('users/avatar-100x100.svg')
  }

  if (user.images && user.images.hasOwnProperty(size)) {
    return user.images[size]
  }

  return user.image_source
}
